module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.entity,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.name),
      callback: function($$v) {
        _vm.$set(_vm.entity, "name", $$v)
      },
      expression: "entity.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "linkmanName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.linkmanName),
      callback: function($$v) {
        _vm.$set(_vm.entity, "linkmanName", $$v)
      },
      expression: "entity.linkmanName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "linkmanTel"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.linkmanTel),
      callback: function($$v) {
        _vm.$set(_vm.entity, "linkmanTel", $$v)
      },
      expression: "entity.linkmanTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.entity.remark),
      callback: function($$v) {
        _vm.$set(_vm.entity, "remark", $$v)
      },
      expression: "entity.remark"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e632ef3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionDispatchChannel/Form.vue
// module id = 320
// module chunks = 0